import apiClient from "./client";

export async function fetchMeProfile(signal) {
  const response = await apiClient.get("me/", { signal });
  return response.data;
}

export async function fetchMyBadges(signal) {
  const response = await apiClient.get("me/badges/", { signal });
  return response.data;
}

export async function fetchMyHistory(signal) {
  const response = await apiClient.get("me/history/", { signal });
  return response.data;
}

export async function fetchPublicProfileBySlug(publicSlug, signal) {
  const response = await apiClient.get(`profiles/${publicSlug}/`, { signal });
  return response.data;
}

export async function fetchPublicProfileByUserId(userId, signal) {
  const response = await apiClient.get(`profiles/user/${userId}/`, { signal });
  return response.data;
}

export async function fetchPublicTeam(teamId, signal) {
  const response = await apiClient.get(`teams/id/${teamId}/`, { signal });
  return response.data;
}

export async function createModerationReport(payload, attachment = null) {
  if (attachment) {
    const form = new FormData();
    Object.entries(payload).forEach(([key, value]) => {
      if (value !== undefined && value !== null) form.append(key, value);
    });
    form.append("attachment", attachment);
    const response = await apiClient.post("moderation/reports/", form, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return response.data;
  }
  const response = await apiClient.post("moderation/reports/", payload);
  return response.data;
}

export async function createBugReport(payload) {
  const response = await apiClient.post("bug-reports/", payload, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return response.data;
}

export async function fetchProfileComments(profileUserId, signal) {
  const response = await apiClient.get(`profiles-by-id/${profileUserId}/comments/`, { signal });
  return response.data;
}

export async function createProfileComment(profileUserId, payload) {
  const response = await apiClient.post(`profiles-by-id/${profileUserId}/comments/`, payload);
  return response.data;
}

export async function deleteProfileComment(profileUserId, commentId) {
  const response = await apiClient.delete(`profiles-by-id/${profileUserId}/comments/${commentId}/`);
  return response.data;
}
